import React from "react";
import { Route } from "react-router-dom";

import Login from "../pages/SHARED/Login";
import GuestRequestSample from "../pages/SHARED/GuestRequestSample";
import Register from "../pages/SHARED/Register";
import FirstTimeRegister from "../pages/SHARED/FirstTimeRegister";
import TeamMemberRegister from "../pages/Carrier Team Member User/TeamMemberRegister";
import InternalUserRegister from "../pages/Internal User/InternalUserRegister";
import LawFirmUserRegister from "../pages/Law Firm User/LawFirmUserRegister";
import ProfessionalGuardianRegister from "../pages/Professional Guardian User/ProfressionalUserGuardianRegister";
import PgContactRegister from "../pages/Professional Guardian Contact User/PgContactRegister";
import UserProfileUpdate from "../pages/SHARED/UserProfileUpdate";
import EnhancementCenter from "../pages/SHARED/EnhancementCenter";

import VermostProbateBondRequestForm from "../pages/SHARED/Bond Creation/ProbateBond";
import VermostGuardianshipBondRequestForm from "../pages/SHARED/Bond Creation/GuardianshipBond";
import VermostVABondRequestForm from "../pages/SHARED/Bond Creation/VABond";
import VermostTrusteeBondRequestForm from "../pages/SHARED/Bond Creation/TrusteeBond";
import VermostBlanketBondRequestForm from "../pages/SHARED/Bond Creation/BlanketBond";

const publicRoutes = [
  <Route key="login" path="/" element={<Login />} />,
  <Route key="register" path="/register" element={<Register />} />,
  <Route key="first-time-register" path="/first-time-register" element={<FirstTimeRegister />} />,
  <Route key="guest-request" path="/guest-request" element={<GuestRequestSample />} />,
  <Route key="profile" path="/profile" element={<UserProfileUpdate />} />,
  <Route key="create-enhancement" path="/create-enhancement-request" element={<EnhancementCenter />} />,
  <Route key="my-enhancements" path="/my-enhancement-requests" element={<EnhancementCenter />} />,

  // Token-based registration routes
  <Route key="team-member-register" path="/team-member-register/:token" element={<TeamMemberRegister />} />,
  <Route key="internal-user-register" path="/internal-user-register/:token" element={<InternalUserRegister />} />,
  <Route key="lawfirm-user-register" path="/lawfirm-user-register/:token" element={<LawFirmUserRegister />} />,
  <Route key="pg-register" path="/professional-guardian-register/:token" element={<ProfessionalGuardianRegister />} />,
  <Route key="pg-contact-register" path="/pg-contact-register/:token" element={<PgContactRegister />} />,

  // Guest bond request routes (no auth required)
  <Route key="probate-guest" path="/vermost-probate-bond-request-guest" element={<VermostProbateBondRequestForm />} />,
  <Route key="guardianship-guest" path="/vermost-guardianship-bond-request-guest" element={<VermostGuardianshipBondRequestForm />} />,
  <Route key="trustee-guest" path="/vermost-trustee-bond-request-guest" element={<VermostTrusteeBondRequestForm />} />,
  <Route key="va-guest" path="/vermost-va-bond-request-guest" element={<VermostVABondRequestForm />} />,
  <Route key="blanket-guest" path="/vermost-blanket-bond-request-guest" element={<VermostBlanketBondRequestForm />} />,
];

export default publicRoutes;
